module.exports = __webpack_public_path__ + "static/media/Empowerment Lounge.f87dbf6e.png";